export default "/assets/Icon/banxa-logo.svg"